import { Col, Container, Paragraph, Row } from 'hui';
import { Facebook, LinkedinIn, Twitter } from 'hui.icons';
import { tint } from 'polished';
import React, { Component } from 'react';
import styled from 'styled-components';
import { EventActions, EventCategories } from '../../constants/Analytics';
import Constants from '../../constants/Articles';
import { loadScript } from './utils';

const SocialButton = styled.button`
  font-size: 1.25em;
  width: 2rem;
  height: 2rem;
  background-color: ${props => props.backgroundColor};

  &&:hover,
  &&:active,
  &&:focus {
    background-color: ${props => tint(0.8, props.backgroundColor)};
  }

  svg {
    position: relative;
    top: 2px;
    fill: ${props => props.theme.colors.tint6};
  }
`;

class Share extends Component {
  componentDidMount() {
    if (typeof window === 'undefined') {
      return;
    }

    // fix sharethis data cache issue when routing changes
    if ((window as any).__sharethis__) {
      (window as any).__sharethis__ = {};
    }

    loadScript(Constants.SHARE_THIS_URL);
  }

  render() {
    return (
      <Container p={0} mb={{ xs: 1, lg: 0 }}>
        <Row alignItems="center" justifyContent="space-between">
          <Col>
            <Paragraph bold mb={0}>
              Share this page
            </Paragraph>
          </Col>
          <Col>
            <SocialButton
              p={0}
              backgroundColor="#334D92"
              data-network="facebook"
              className="st-custom-button"
              data-ga-category={EventCategories.ARTICLES}
              data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
              data-ga-label="[Facebook]"
            >
              <Facebook />
            </SocialButton>
            <SocialButton
              p={0}
              backgroundColor="#00A3EA"
              ml={0.5}
              data-network="twitter"
              className="st-custom-button"
              data-ga-category={EventCategories.ARTICLES}
              data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
              data-ga-label="[Twitter]"
            >
              <Twitter />
            </SocialButton>
            <SocialButton
              p={0}
              backgroundColor="#0070AD"
              ml={0.5}
              data-network="linkedin"
              className="st-custom-button"
              data-ga-category={EventCategories.ARTICLES}
              data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
              data-ga-label="[LinkedIn]"
            >
              <LinkedinIn />
            </SocialButton>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Share;
